export default {
  Drilling: {
    DailyReports: {
      UploadVue2: "Drilling.UploadVue2"
    }
  },
  Core: {
    ProjectFilter: {
      CanadianMalartic: "IsCanadianMalartic",
      Corporate: "IsCorporate",
      Nsr: "NsrProjectFilter"
    }
  },
  Geo: {
    MRMR: {
      QpEngineeringApproval: "Geo.MRMR.QpEngineeringApproval"
    }
  }
}